/**
 * 模块: useSearchPerformance Operation Handlers
 * 职责: 操作处理函数（上传、删除等）
 * 限制: <280行
 */

import type { MessageInstance } from 'antd/es/message/interface';
import { searchPerformanceAPI } from '../../services/searchPerformanceAPI';
import type { SearchPerformancePeriod } from '../../types';

/**
 * 创建CSV上传处理器
 */
export const createUploadCSVHandler = (
  skuId: number,
  setLoading: (loading: boolean) => void,
  fetchPeriods: () => Promise<void>,
  message: MessageInstance
) => {
  return async (file: File): Promise<SearchPerformancePeriod | null> => {
    setLoading(true);
    try {
      const response = await searchPerformanceAPI.upload(skuId, file);

      // 显示验证信息
      if (response.data.validation_info && response.data.validation_info.length > 0) {
        console.log('验证信息:', response.data.validation_info);
      }

      // 显示警告
      if (response.data.warnings && response.data.warnings.length > 0) {
        response.data.warnings.forEach((warning) => {
          message.warning(warning);
        });
      }

      message.success('搜索查询绩效数据上传成功');

      // 刷新周期列表
      await fetchPeriods();

      return response.data.period;
    } catch (error: any) {
      const errorMsg = error.response?.data?.error || error.message;
      const errors = error.response?.data?.errors || [];

      if (errors.length > 0) {
        message.error(`上传失败: ${errors.join(', ')}`);
      } else {
        message.error(`上传失败: ${errorMsg}`);
      }

      return null;
    } finally {
      setLoading(false);
    }
  };
};

/**
 * 创建删除周期处理器
 */
export const createDeletePeriodHandler = (
  setLoading: (loading: boolean) => void,
  fetchPeriods: () => Promise<void>,
  message: MessageInstance
) => {
  return async (periodId: number) => {
    setLoading(true);
    try {
      await searchPerformanceAPI.deletePeriod(periodId);
      message.success('周期删除成功');
      await fetchPeriods();
    } catch (error: any) {
      message.error(`删除失败: ${error.response?.data?.error || error.message}`);
    } finally {
      setLoading(false);
    }
  };
};
